import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { styled } from '../../../../../../../../../core/theme/styled';

export const TemplateNoticeContainer = styled.div.attrs({
  'data-testid': 'login-template-disclaimer',
})`
  display: flex;
  flex: 1;
  align-items: flex-start;
  margin-top: ${(props) => props.theme.sizes.xsmall};
`;

export const TemplateNoticeText = styled(Box)`
  border-left: 1px solid ${(props) => props.theme.configuration.strokeColor};
`;
